export default "__VITE_ASSET__BxmP9Xqi__"